import { initKpiSlice, KpiCommands } from '@skynet/data-shared-kpi';
import { resetStore } from 'src/store/actions';

export enum RetainerKpiCommands {
  KPI = 'RetainerKPI',
}

const { reducer, actions } = initKpiSlice({
  prefix: 'retainers',
  sliceName: 'retainersKpi',
  commands: { ...KpiCommands, ...RetainerKpiCommands },
  resetAction: resetStore,
});

export const retainersKpiActions = actions;
export default reducer;
